import toast from 'react-hot-toast';

export const Success = (message) => toast.success(message);
export const Warning = (message) => toast(message, { icon: '⚠️' });
export const Error = (message) => toast.error(message);
